/**
 * Legacy portal mapped fixed codes to synthetic discount end dates.
 * Membership promotions are resolved in Stripe; the client no longer derives end dates from code strings.
 */
export function getDiscountEndDate(_discountCode: string): Date | null {
  return null;
}
